import $ from 'jquery'

/* ============================================================================
Ajax the add to cart experience by revealing it in a side drawer
Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
(c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

This file includes:
  - Basic Shopify Ajax API calls
  - Ajax cart plugin

This requires:
  - jQuery 1.8+
  - handlebars.min.js (for cart template)
  - modernizr.min.js
  - snippet/ajax-cart-template.liquid

Customized version of Shopify's jQuery API
(c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
============================================================================== */
let ShopifyAPI
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {} }

if ((typeof Shopify) === 'undefined') { Shopify = {} }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function (cents, format) {
    let value = '',
      placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = (format || this.money_format)

    if (typeof cents === 'string') {
      cents = cents.replace('.', '')
    }

    function defaultOption (opt, def) {
      return (typeof opt === 'undefined' ? def : opt)
    }

    function formatWithDelimiters (number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2)
      thousands = defaultOption(thousands, ',')
      decimal = defaultOption(decimal, '.')

      if (isNaN(number) || number == null) {
        return 0
      }

      number = (number / 100.0).toFixed(precision)

      let parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`),
        cents = parts[1] ? (decimal + parts[1]) : ''

      return dollars + cents
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2)
        break
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0)
        break
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',')
        break
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',')
        break
    }

    return formatString.replace(placeholderRegex, value)
  }
}

/* ============================================================================
API Helper Functions
============================================================================== */
function attributeToString (attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += ''
    if (attribute === 'undefined') {
      attribute = ''
    }
  }
  return $.trim(attribute)
};

/* ============================================================================
API Functions
============================================================================== */
ShopifyAPI.onCartUpdate = function (cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
}

ShopifyAPI.updateCartNote = function (note, callback) {
  let $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/update.js',
      data: `note=${attributeToString(note)}`,
      dataType: 'json',
      beforeSend () {
        $body.trigger('beforeUpdateCartNote.ajaxCart', note)
      },
      success (cart) {
        if ((typeof callback) === 'function') {
          callback(cart)
        } else {
          ShopifyAPI.onCartUpdate(cart)
        }
        $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart])
      },
      error (XMLHttpRequest, textStatus) {
        $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus])
        ShopifyAPI.onError(XMLHttpRequest, textStatus)
      },
      complete (jqxhr, text) {
        $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text])
      }
    }
  $.ajax(params)
}

ShopifyAPI.onError = function (XMLHttpRequest, textStatus) {
  const data = eval(`(${XMLHttpRequest.responseText})`)
  if (data.message) {
    alert(`${data.message}(${data.status}): ${data.description}`)
  }
}

/* ============================================================================
POST to cart/add.js returns the JSON of the cart
  - Allow use of form element instead of just id
  - Allow custom error callback
  ============================================================================== */
ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {
  let $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/add.js',
      data: $(form).serialize(),
      dataType: 'json',
      beforeSend (jqxhr, settings) {
        $body.trigger('beforeAddItem.ajaxCart', form)
      },
      success (line_item) {
        if ((typeof callback) === 'function') {
          callback(line_item, form)
        } else {
          ShopifyAPI.onItemAdded(line_item, form)
        }
        $body.trigger('afterAddItem.ajaxCart', [line_item, form])
      },
      error (XMLHttpRequest, textStatus) {
        if ((typeof errorCallback) === 'function') {
          errorCallback(XMLHttpRequest, textStatus)
        } else {
          ShopifyAPI.onError(XMLHttpRequest, textStatus)
        }
        $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus])
      },
      complete (jqxhr, text) {
        $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text])
      }
    }
  $.ajax(params)
}

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function (callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart')
  $.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart)
    } else {
      ShopifyAPI.onCartUpdate(cart)
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart)
  })
}

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function (line, quantity, callback) {
  let $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/change.js',
      data: `quantity=${quantity}&line=${line}`,
      dataType: 'json',
      beforeSend () {
        $body.trigger('beforeChangeItem.ajaxCart', [line, quantity])
      },
      success (cart) {
        if ((typeof callback) === 'function') {
          callback(cart)
        } else {
          ShopifyAPI.onCartUpdate(cart)
        }
        $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart])
      },
      error (XMLHttpRequest, textStatus) {
        $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus])
        ShopifyAPI.onError(XMLHttpRequest, textStatus)
      },
      complete (jqxhr, text) {
        $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text])
      }
    }
  $.ajax(params)
}

window.ajaxCart = (function (module, $) {
  'use strict'

  // Public functions
  let init, loadCart

  // Private general variables
  let settings, isUpdating, $body

  // Private plugin variables
  let $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer

  // Private functions
  let updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback,
    buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors,
    validateQty

  /* ============================================================================
  Initialise the plugin and define global options
  ============================================================================== */
  init = function (options) {
    // Default settings
    settings = {
      formSelector: 'AddToCartForm',
      cartContainer: '#CartContainer',
      addToCartSelector: '#AddToCart',
      cartCountSelector: null,
      cartCostSelector: null,
      moneyFormat: '${{amount}}',
      disableAjaxCart: false,
      enableQtySelectors: true
    }

    // Override defaults with arguments
    $.extend(settings, options)

    // Select DOM elements
    $formContainer = $(settings.formSelector)
    $cartContainer = $(settings.cartContainer)
    $addToCart = $formContainer.find(settings.addToCartSelector)
    $cartCountSelector = $(settings.cartCountSelector)
    $cartCostSelector = $(settings.cartCostSelector)

    // General Selectors
    $body = $(document.body)

    // Track cart activity status
    isUpdating = false

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors()
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride()
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart()
  }

  loadCart = function () {
    ShopifyAPI.getCart(cartUpdateCallback)
  }

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      let qty = 0
      $.each(cart.items, function (index, cartItem) {
        if (cartItem.handle == 'product-options') {
          qty += cartItem.quantity
        }
      })

      $cartCountSelector.html(cart.item_count - qty).removeClass('hidden-count')

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count')
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat))
    }
  }

  formOverride = function () {
    $formContainer.on('submit', function (evt) {
      evt.preventDefault()

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding')

      // Remove any previous quantity errors
      $('.qty-error').remove()

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback)
    })
  }

  itemAddedCallback = function (product) {
    console.log("item added callback")
    $addToCart.removeClass('is-adding').addClass('is-added')

    ShopifyAPI.getCart(cartUpdateCallback)
    $('.drw-Drawer_Backdrop').addClass('drw-Drawer_Backdrop-active')
    $('.drw-Drawer-cart').addClass('drw-Drawer-active')
    $('.bdy-Body').addClass('drw-Drawer-active')

    setTimeout(function () {
      $addToCart.removeClass('is-added')
    }, 1000)
  }

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    const data = eval(`(${XMLHttpRequest.responseText})`)
    $addToCart.removeClass('is-adding is-added')

    if (data.message) {
      if (data.status == 422) {
        $formContainer.after(`<div class="errors qty-error">${data.description}</div>`)
      }
    }
  }

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart)
    buildCart(cart)
  }

  buildCart = function (cart) {
    if (window.BOLD && BOLD.common && BOLD.common.cartDoctor && typeof BOLD.common.cartDoctor.fix === 'function') {
      cart = BOLD.common.cartDoctor.fix(cart)
    }

    // Start with a fresh cart div
    $cartContainer.empty()

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append(`<div class="ajx-Empty">
                  <span class="ajx-Empty_Icon"><svg viewBox="0 0 15 19"><path d="M13.312 14.345H1.438v-9c0-.33.267-.595.593-.595h1.782v2.375H5V4.75h4.75v2.375h1.187V4.75h1.782c.326 0 .593.266.593.594v9.001zm0 2.873a.595.595 0 0 1-.593.595H2.03a.595.595 0 0 1-.593-.595v-2.877h11.874v2.877zM5 2.97a1.78 1.78 0 0 1 1.781-1.78H7.97a1.78 1.78 0 0 1 1.78 1.78v.593H5V2.97zm5.937.593V2.97A2.97 2.97 0 0 0 7.97 0H6.78a2.97 2.97 0 0 0-2.968 2.97v.592H1.438A1.19 1.19 0 0 0 .25 4.75v13.063C.25 18.47.785 19 1.438 19h11.874c.653 0 1.188-.53 1.188-1.187V4.75a1.19 1.19 0 0 0-1.188-1.188h-2.375z" fill="currentColor" fill-rule="evenodd"/>
</svg></span>
                  <p class="ajx-Empty_Content">Your bag is currently empty.</p>
                  <a href="/collections/all" class="btn-Primary ajx-EmptyButton">View our collection</a>
                </div>`)
      cartCallback(cart)
      return
    }

    // Handlebars.js cart layout
    let items = [],
      item = {},
      data = {},
      source = $('#CartTemplate').html(),
      template = Handlebars.compile(source)


    // Add each item to our handlebars.js data
    $.each(cart.items, function (index, cartItem) {
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
       */
      if (cartItem.image != null) {
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, '_medium$1').replace('http:', '')
      } else {
        var prodImg = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif'
      }

      const price = cartItem.price

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price !== cartItem.original_line_price
      }
        items.push(item)
    })

    // Gather all cart data and add to DOM
    data = {
      items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : "'You're saving [savings]'".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
      totalCartDiscountApplied: cart.total_discount !== 0
    }

    $cartContainer.append(template(data))

    cartCallback(cart)
  }

  cartCallback = function (cart) {
    $body.trigger('afterCartLoad.ajaxCart', cart)

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize()
    }
  }

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function () {
      if (isUpdating) {
        return
      }

      var $el = $(this),
        line = $el.data('line'),
        $qtySelector = $el.siblings('.ajaxcart__qty-num'),
        qty = parseInt($qtySelector.val().replace(/\D/g, ''))

      var qty = validateQty(qty)

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1
      } else {
        qty -= 1
        if (qty <= 0) qty = 0
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty)
      } else {
        $qtySelector.val(qty)
      }
    })

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function () {
      if (isUpdating) {
        return
      }

      var $el = $(this),
        line = $el.data('line'),
        qty = parseInt($el.val().replace(/\D/g, ''))

      var qty = validateQty(qty)

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty)
      }
    })

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function (evt) {
      if (isUpdating) {
        evt.preventDefault()
      }
    })

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function () {
      const $el = $(this)
      setTimeout(function () {
        $el.select()
      }, 50)
    })

    function updateQuantity (line, qty) {
      isUpdating = true

      // Add activity classes when changing cart quantities
      const $row = $(`.ajaxcart__row[data-line="${line}"]`).addClass('is-loading')

      if (qty === 0) {
        $row.parent().addClass('is-removed')
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function () {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback)
      }, 250)
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function () {
      const newNote = $(this).val()

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function (cart) {})
    })
  }

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart)

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function () {
      isUpdating = false
      ShopifyAPI.getCart(buildCart)
    }, 150)
  }

  createQtySelectors = function () {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function () {
        let $el = $(this),
          currentQty = $el.val()

        let itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty

        let source = $('#AjaxQty').html(),
          template = Handlebars.compile(source),
          data = {
            key: $el.data('id'),
            itemQty,
            itemAdd,
            itemMinus
          }

        // Append new quantity selector then remove original
        $el.after(template(data)).remove()
      })
    }
  }

  qtySelectors = function () {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    const numInputs = $('input[type="number"]')

    if (numInputs.length) {
      numInputs.each(function () {
        let $el = $(this),
          currentQty = $el.val(),
          inputName = $el.attr('name'),
          inputId = $el.attr('id')

        let itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty

        let source = $('#JsQty').html(),
          template = Handlebars.compile(source),
          data = {
            key: $el.data('id'),
            itemQty,
            itemAdd,
            itemMinus,
            inputName,
            inputId
          }

        // Append new quantity selector then remove original
        $el.after(template(data)).remove()
      })

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function () {
        var $el = $(this),
          id = $el.data('id'),
          $qtySelector = $el.siblings('.js-qty__num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''))

        var qty = validateQty(qty)

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1
        } else {
          qty -= 1
          if (qty <= 1) qty = 1
        }

        // Update the input's number
        $qtySelector.val(qty)
      })
    }
  }

  validateQty = function (qty) {
    if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1
    }
    return qty
  }

  module = {
    init,
    load: loadCart
  }

  return module
}(window.ajaxCart || {}, $))
